"use strict";
// This file is auto-generated by @hey-api/openapi-ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.getReviewStatisticsV1 = exports.getReviewsV1 = void 0;
/**
 * Get reviews
 * @param data The data for the request.
 * @param data.amountOfReviews Maximum amount of reviews to be returned
 * @param data.page The page to request.
 * @param data.minimumScore The minimum score of the returned reviews
 * @param data.location The location for which the reviews API should report back on. Falls back to the default brand if not provided
 * @returns GetReviewsResponseWithStatistics OK
 * @throws ApiError
 */
const getReviewsV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/reviews/reviews/v1',
        query: {
            minimum_score: data.minimumScore,
            amount_of_reviews: data.amountOfReviews,
            page: data.page,
            location: data.location
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getReviewsV1 = getReviewsV1;
/**
 * Get review statistics
 * @param data The data for the request.
 * @param data.location The location for which the reviews API should report back on. Falls back to the default brand if not provided
 * @returns GetReviewStatisticsResponse OK
 * @throws ApiError
 */
const getReviewStatisticsV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/reviews/review-statistics/v1',
        query: {
            location: data.location
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getReviewStatisticsV1 = getReviewStatisticsV1;
